<template>
    <div class="ts-overflow-scroll ts-max-h-screen p-4 bg-gray-50 rounded-lg shadow-sm">

        <div class="d-flex justify-content-between mb-2">
            <div style="width: 70px;">
                <ts-button class="btn-block" outline color="success" @click.prevent="exportExcel" :waiting="exporting">
                    {{ $t('excel') }}
                </ts-button>
            </div>

            <ts-input v-model="searchDetail" :placeholder="$t('eventManagement.searchEvDetail')"
                style="width: 300px;" />
        </div>


        <!-- Table -->
        <ts-table :columns="columns" :records="filteredData" class="w-full mt-2">
            <template v-slot="{ record, index }">
                <td class="text-center px-2 py-1">{{ index + 1 }}</td>
                <td class="text-center px-2 py-1">{{ record.registration_no }}</td>
                <td class="px-2 py-1">{{ record.name }}</td>
                <td class="text-center px-2 py-1">{{ record.sex }}</td>
                <td class="text-right px-2 py-1">{{ record.phone }}</td>
                <td class="text-center px-2 py-1">{{ record.created_date }}</td>
            </template>
        </ts-table>
    </div>
</template>

<script>
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'
import { Errors } from 'form-backend-validation'

export default {
    name: 'viewStudentList',
    props: {
        value: Array,
        eventId: [String, Number]
    }, data() {
        return {
            data: this.value || [],
            searchDetail: '',
            exporting: false,
            model: {
                event_mgt_id: ''
            },
        }
    },
    mounted() {
        this.model.event_mgt_id = this.eventId
    },
    computed: {
        columns() {
            return [
                { name: this.$t('eventManagement.no'), style: 'text-align:center;width:50px;' },
                { name: this.$t('eventManagement.registeredNo'), style: 'text-align:center;width:100px;' },
                { name: this.$t('eventManagement.name'), style: 'width:200px;' },
                { name: this.$t('eventManagement.sex'), style: 'text-align:center;width:50px;' },
                { name: this.$t('eventManagement.phone'), style: 'text-align:right;width:120px;' },
                { name: this.$t('eventManagement.registeredDate'), style: 'text-align:center;width:120px;' },
            ]
        },
        filteredData() {
            if (!this.searchDetail) return this.data;

            const search = this.searchDetail.toLowerCase();
            return this.data.filter(student =>
                (student.registration_no && student.registration_no.toLowerCase().includes(search)) ||
                (student.name && student.name.toLowerCase().includes(search)) ||
                (student.sex && student.sex.toLowerCase().includes(search)) ||
                (student.phone && student.phone.toLowerCase().includes(search)) ||
                (student.created_date && student.created_date.toLowerCase().includes(search))
            );
        }

    },

    methods: {
        exportExcel() {
            console.log(this.model);

            this.exporting = true
            this.errors = new Errors()

            this.$store
                .dispatch('eventManagement/eventManagementDetailExcel', this.model)
                .then(response => {
                    let filename = trim(
                        response.headers['content-disposition']
                            .substring(
                                response.headers['content-disposition'].indexOf('filename')
                            )
                            .replace('filename=', ''),
                        '"'
                    )
                    FileDownload(response.data, filename)
                })
                .catch(err => {
                    let error = JSON.parse(
                        String.fromCharCode.apply(null, new Uint8Array(err))
                    )
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
                .finally(() => (this.exporting = false))
        }
    },
    watch: {
        eventId(newVal) {
            this.model.event_mgt_id = newVal
        },
        value(newVal) {
            this.data = newVal || []
        }
    },
    mounted() {
        this.model.event_mgt_id = this.eventId
        this.data = this.value || []
    }

}
</script>
